:host {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}

.wrapper {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  padding: 1rem;
  border-radius: 8px;
  background: #FAFAFA;
  border: 1px solid #f2f2f2;
  color: #484848;
}

.icon__wrapper {
  padding-right: 1rem;
}

.icon__wrapper svg {
  width: 2em;
  height: 2em;
  color: #484848;
  background: #f2f2f2;
  border-radius: 100%;
  padding: .75rem;
}

.content__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.primary {
  font-size: 1em;
  font-weight: 600;
}

.primary a {
  color: currentColor;
  text-underline-offset: 4px;
}

.content__wrapper:not(.heading) {
  font-size: .85em;
}

.links>div:first-child {
  margin-bottom: 5px;
}